import styled from 'styled-components';

export const ReviewBodySection = styled.section(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    background-color: ${props.theme.colors.white.bgWhite};
  `,
);

export const BlueBackGroundWrapper = styled.section(
  props => `
    width:100%;
    background-color: ${props.theme.colors.blue.brand};
    position:absolute;
    right:0;
    left:0;
    height:20rem;
    `,
);

export const ReviewMainComponentWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 120rem;
    margin: 0 auto;
    width:100%;
    padding-top:${props.theme.spacing.large.l15};
    padding-bottom:${props.theme.spacing.large.l25};
    z-index: 1;
  `,
);

export const ReviewMainComponentLeftBlock = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:68%;
    padding-right:${props.theme.spacing.large.l20};
  `,
);

export const ReviewMainComponentRightBlock = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 32%;
  `,
);

export const ErrorMessageContainer = styled.ul(
  props => `
    padding: ${props.theme.spacing.large.l20};
    border-top: 2px solid ${props.theme.colors.goBrand.bgBlue}
    font-size: ${props.theme.font.large.font16}
    list-style-type: none;
`,
);

export const ContinueBtn = styled.button(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.white.base};
    font-weight: bold;
    background-color: ${props.theme.colors.blue.base};
    outline: none;
    border: none;
    cursor: pointer;
    margin-top: ${props.theme.spacing.large.l15};
    margin-right: ${props.theme.spacing.large.l15};
    display: flex;
    align-self: flex-end;
    margin-bottom: ${props.theme.spacing.large.l15};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    border-radius: .4rem;
  `
);

export const PopInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
  `
)